import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Toast } from 'react-weui';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import Http from 'services/http2';
import * as MobileActions from '../../actions';
import Validation from 'services/validation';
import Matching from 'components/matching';
import { formatDate } from 'lib/formatter';
import User from 'services/user2';
import EmployeeJoin from 'components/employeeJoin';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';

//http://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Fcreate-company&response_type=code&scope=snsapi_base&state=123#wechat_redirect
//https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf3cf604fbe16e419&redirect_uri=http%3A%2F%2Fdev.xiekeyun.com%2Fmp%2Flogin&response_type=code&scope=snsapi_base&state=123#wechat_redirect

const styles = theme => ({
  createBox: {
    padding: '15px',
  },
  inputBox: {
    width: '100%',
    margin: '0 0 10px',
  },
  button: {
    width: '100%',
    height: '50px',
    fontSize: '16px',
    marginBottom: 10,
  },
  labelCheckbox: {
    margin: 0,
    display: 'inline-block',
    verticalAlign: 'bottom',
  },
  checkbox: {
    padding: 0,
    verticalAlign: 'bottom',
  },
  isRegistered: {
    padding: '5px 10px',
    border: '1px solid #b2e2ea',
    backgroundColor: '#e5f2f8',
    position: 'relative',
    fontSize: 12,
    margin: '10px 0',
  },
  error: {
    lineHeight: '1.5em',
  },
  dialogTitle: {
    position: 'relative',
    textAlign: 'center',
    padding: '20px',
  },
  closeIcon: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
    fontSize: 20,
  },
  dialogActions: {
    margin: 0,
    display: 'block',
  },
  affBt: {
    width: '100%',
    margin: 0,
    borderRadius: 0,
  },
  joinTip: { margin: '30px 0 10px 0' },
});

class CreateCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: '',
      creditCode: '',
      error: null,
      companyNameError: false,
      creditCodeError: false,
      isAgree: false,
      open: false,
      list: [],
      total: 0,
      showError: false,
      isRegistered: false,
      path: null,
      showToast: false,
      showLoading: false,
    };
    this.error = {
      companyName: '',
      creditCode: '',
    };
    this.validationConfig = this.validationConfig.bind(this);
    this.errorFn = this.errorFn.bind(this);
    this.timer = '';
    this.errorMsg = '';
    this.registerData = {};
  }

  init() {
    window.scrollTo(0, 0);
  }

  componentDidMount() {
    this.forceUpdate();
  }

  //获取邀约信息列表
  // async getInviteByPhone() {
  //   const { mobile, mobileArea } = User.getUserInfo();
  //   const postbody = {
  //     receiverMobile: mobile,
  //     receiverMobileArea: mobileArea,
  //     apiPath: '/inviteToken/getInviteByPhone'
  //   }
  //   let arr = [];
  //   await Http.post('/api/cloudCenter', postbody).then(response => {
  //     if ( response.success ) {
  //       arr = response.data;
  //     }
  //   });
  //   return arr;
  // }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value, isRegistered: false });
    if (name === 'companyName') {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.getCompanyList();
      }, 500);
    }
  };

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  validationConfig() {
    return {
      companyName: {
        value: this.state.companyName.trim(),
        rules: ['required'],
      },
      creditCode: {
        value: this.state.creditCode.trim(),
        rules: ['required', 'creditCode'],
      },
    };
  }

  getCompanyList() {
    if (this.state.companyName.length < 2) {
      this.setState({ list: [], total: 0 });
      return;
    }
    let postbody = {
      pageNum: 1,
      pageSize: 10,
      companyName: this.state.companyName,
      apiPath: '/companyCreditCode/getPageList',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        this.setState({ list: response.data.list, total: response.data.total });
      }
    });
  }

  // 注册企业
  createClick = () => {
    if (!this.check()) {
      return;
    }
    this.setState({ showLoading: true });
    const postbody = {
      companyName: this.state.companyName.trim(),
      creditCode: this.state.creditCode.trim(),
      apiPath: '/archives/company/createCompany',
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      this.setState({ showLoading: false });
      if (response.success) {
        User.refreshUserInfo().then(item => {
          this.props.history.push('/mp/index');
        });
      } else {
        if (response.errorCode === 'ERR_CODE_024') {
          //已被注册
          this.registerData = response.data;
          this.error['creditCode'] =
            '该企业已经在携客云注册，请联络该企业创建人，若企业被冒用请拨客服电话。';
          this.setState({ isRegistered: true, creditCodeError: true });
          return;
        }
        let responseMsg = response.errorMsg;
        this.errorFn(responseMsg);
      }
    });
  };

  // 员工加入公司
  joinClick = () => {
    const { actions } = this.props;
    actions.openEmployeeJoinModal();
  };

  handleModalChange = data => {
    if (data === 'success') {
      this.setState({ showToast: true });
      setTimeout(() => {
        this.props.history.push('/mp/index');
      }, 3000);
    }
  };

  check() {
    let result = true;
    this.error = {};
    this.setState({ creditCodeError: false, companyNameError: false });
    if (this.state.isAgree !== true) {
      this.error['creditCode'] = '请先阅读并同意《企业使用协议》';
      this.setState({ creditCodeError: true });
      return false;
    }
    if (!Validation.validateAll(this.validationConfig(), this.error)) {
      result = false;
    }

    if (!this.checkCompanyName()) {
      this.error['companyName'] = '请输入企业工商注册全称';
      result = false;
    }
    let arr = [];
    for (let i in this.error) {
      arr.push(i + 'Error');
    }
    this.setState({
      creditCodeError: arr.indexOf('creditCodeError') !== -1,
      companyNameError: arr.indexOf('companyNameError') !== -1,
    });
    return result;
  }

  checkCompanyName() {
    let filterKeys = [
      '公司',
      '有限公司',
      '有限责任公司',
      '责任有限公司',
      '集团',
      '股份有限公司',
      '科技有限公司',
    ];
    let companyName = this.state.companyName.trim();
    if (
      companyName.length < 6 ||
      filterKeys.some(item => item === companyName)
    ) {
      return false;
    }
    return true;
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  affClick = () => {
    this.setState({ open: false, isAgree: true });
  };

  matchingChange = item => {
    if (item) {
      this.setState({ list: [], total: 0, companyName: item.companyName });
    } else {
      this.setState({ list: [], total: 0 });
    }
  };

  errorFn(errorMsg) {
    this.errorMsg = errorMsg;
    this.setState({ showError: true });
    this.errorTimer = setTimeout(() => {
      this.setState({ showError: false });
    }, 2000);
  }

  render() {
    // const { data, actions } = this.props;
    const { classes } = this.props;
    return (
      <div className={classes.createBox}>
        <div className="m-logo">
          <img src="/assets/img/logo@2x.png" alt="" />
          <span className="label">注册企业</span>
        </div>
        <FormControl className={classes.inputBox} variant="outlined">
          <InputLabel
            htmlFor="companyName"
            ref={ref => {
              this.labelRef = ReactDOM.findDOMNode(ref);
            }}
          >
            企业工商注册全称
          </InputLabel>
          <OutlinedInput
            id="companyName"
            value={this.state.companyName}
            onChange={this.handleChange('companyName')}
            labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
          />
          <FormHelperText
            className={classes.error}
            error={this.state.companyNameError}
          >
            {this.error.companyName}
          </FormHelperText>
          {this.state.list.length !== 0 && this.state.total !== 0 && (
            <Matching
              list={this.state.list}
              total={this.state.total}
              onChange={this.matchingChange}
            />
          )}
        </FormControl>
        <FormControl className={classes.inputBox} variant="outlined">
          <InputLabel
            htmlFor="creditCode"
            ref={ref => {
              this.labelRef2 = ReactDOM.findDOMNode(ref);
            }}
          >
            企业统一社会信用代码
          </InputLabel>
          <OutlinedInput
            id="creditCode"
            value={this.state.creditCode}
            onChange={this.handleChange('creditCode')}
            labelWidth={this.labelRef2 ? this.labelRef2.offsetWidth : 0}
          />
          <FormHelperText
            className={classes.error}
            error={this.state.creditCodeError}
          >
            {this.error.creditCode}
          </FormHelperText>
        </FormControl>
        {this.state.isRegistered && (
          <div className={classes.isRegistered}>
            <p>企业名称：{this.registerData.companyName}</p>
            <p>创建人：{this.registerData.regUserName}</p>
            <p>手机：{this.registerData.mobile}</p>
            <p>创建日期：{formatDate(this.registerData.createTime)}</p>
          </div>
        )}
        <Button
          variant="contained"
          color="primary"
          onClick={this.createClick}
          className={classes.button}
        >
          注册企业
        </Button>
        <div>
          <FormControlLabel
            className={classes.labelCheckbox}
            control={
              <div>
                <Checkbox
                  className={classes.checkbox}
                  checked={this.state.isAgree}
                  onChange={this.handleCheckChange('isAgree')}
                  value="checkedB"
                  color="primary"
                />
                <span>我已阅读并同意</span>
              </div>
            }
          />
          <a onClick={this.handleClickOpen} style={{ color: 'blue' }}>
            企业使用协议
          </a>
        </div>
        <p className={classes.joinTip}>或者您收到管理员的邀约信息，可以：</p>
        <Button
          variant="outlined"
          color="primary"
          onClick={this.joinClick}
          className={classes.button}
        >
          员工加入企业
        </Button>
        <EmployeeJoin onChange={this.handleModalChange} />
        <Dialog
          open={this.state.open}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
            <div>
              <h3>携客云服务用户协议</h3>
              {
                //<CloseIcon className={classes.closeIcon} onClick={this.handleClose} />
              }
            </div>
          </DialogTitle>
          <DialogContent>
            <div className="p-agreement">
              <h3>1.服务协议及签订</h3>
              <ul>
                <li>
                  本服务协议是使用携客云服务的用户（以下简称“用户”或“您”，用户包括注册使用的企业以及个人用户）与深圳市携客互联科技有限公司（以下简称“我方”）就携客云供应链平台（www.xiekeyun.com）的使用等相关事宜所签订的协议。
                </li>
                <li>
                  请您在点击“同意”按钮之前，详细阅读本协议，您可以选择不接受该协议条款，或在有疑问情况下我方联系，我方将详细解释条款内容，如您不同意该条款的任一条内容，请停止注册过程，但您点击“同意”按钮并提交后，将默认为同意该条款内容，依据《中华人民共和国合同法》《中华人民共和国电信条例》《互联网信息服务管理办法》等相关法律法规的规定，本协议即构成双方合法有效、对双方具有约束力的法律文件。
                </li>
              </ul>

              <h3>2.携客云服务</h3>
              <ul>
                <li>
                  携客云服务：指深圳市携客互联科技有限公司公司向用户提供的在（www.xiekeyun.com）网站和平台上所展示的携客云产品应用，以及相关我方提供的技术或网络支持服务。
                </li>
                <li>
                  服务费用：是您为购买携客云平台服务所支付的费用，具体费用金额将在您订购页面予以列明公示，或者由《服务购买订单》约定。若所购买的服务项目有约定的服务期限，在服务期限到期后持续使用“携客云服务”，需要在约定服务到期前进行服务的续费。
                </li>
              </ul>

              <h3>3.用户的注册</h3>
              <ul>
                <li>
                  3.1 用户注册包括在携客云平台上所注册的企业用户及个人用户；
                </li>
                <li>
                  3.2
                  用户保证提供的注册信息（包括但不限于个人信息、企业信息等）真实、及时、完整和准确。如果信息有变动，用户应及时通知本平台，若用户未及时通知或提供注册的信息不真实、不准确、不合法，由此产生的一切法律责任及后果（包括本平台的损失）均由用户自行承担。同时，本平台有权暂停或终止向用户提供全部或部分服务。
                </li>
                <li>
                  3.3
                  携客云平台的注册账号所有权归属深圳市携客互联科技有限公司，注册完成后，您可获得账号使用权。使用权仅归属于初始申请注册人，不得以任何方式转让或被提供予他人使用，否则，我方有权立即不经通知收回该账号，由此带来的因您使用本服务产生的全部数据、信息等被清空、丢失等的损失，您应自行承担。
                </li>
                <li>
                  3.4
                  用户注册成功后，将产生用户名及密码等用户信息，用户有更改密码的权利。用户应当妥善、谨慎的保管和使用账户信息，不得利用该账户从事违法犯罪或侵犯他人合法权益的行为。若用户发现用户密码被盗，请立即通知我方或向司法机关报案。
                </li>
                <li>
                  3.5
                  未经我方同意，用户不得将注册成功的账户提供给其他方使用，否则由此产生的法律责任，由注册用户与实际使用人承担连带责任。
                </li>
                <li>
                  3.6
                  我方有理由相信用户正在利用本平台从事违法活动，或依据司法行政机关的法律文书或命令，本平台有权依法进行相应的证据保全。
                </li>
                <li>
                  3.7
                  您了解并同意，如您注册携客云账号后连续超过12个月未登录，我方出于网站优化管理之目的有权回收该账号，相关问题及责任均由您自行承担。
                </li>
                <li>
                  3.8
                  我方根据本协议收回或取消账号后，有权自行对账号相关内容及信息以包括但不限于删除等方式进行处理，且无需就此向用户承担任何责任。
                </li>
              </ul>

              <h3>4．您的权利与义务</h3>
              <ul>
                <li>
                  4.1 您将获得所获得（包括免费和已购买）的携客云服务内容的使用。
                </li>
                <li>
                  4.2
                  您同意遵守本服务条款以及服务展示页面的相关管理规范及流程。您了解上述协议及规范等的内容可能会不时变更。如本服务条款的任何内容发生变动，我方应通过提前30天在（www.xiekeyun.com）的适当版面公告向您提示修改内容。如您不同意我方对服务条款相关条款所做的修改，您有权停止使用携客云服务。{' '}
                </li>
                <li>
                  4.3
                  您应按照双方所签订的《服务购买订单》的相关约定支付相应服务费用，并且在约定的服务到期前提交续交服务费用。{' '}
                </li>
                <li>
                  4.4 您承诺：
                  <ul>
                    <li>
                      4.4.1
                      如果您使用携客云服务进行的经营活动需要获得国家有关部门的许可或批准的，应获得该有关的许可或批准。并应符合国家及地方不时颁布相关法律法规之要求；
                    </li>
                    <li>
                      4.4.2
                      若我方的服务涉及第三方软件之许可使用的，您同意遵守相关的许可协议的约束；
                    </li>
                    <li>
                      4.4.3
                      不利用携客云服务提供的资源和服务上传（Upload）、下载（download）、储存、发布如下信息或者内容，不为他人发布该等信息提供任何便利：
                      <p>a) 违反国家规定的政治宣传和/或新闻信息；</p>
                      <p>b) 涉及国家秘密和/或安全的信息；</p>
                      <p>
                        c) 封建迷信和/或淫秽、色情、下流的信息或教唆犯罪的信息；
                      </p>
                      <p>
                        d)
                        博彩有奖、赌博游戏、“私服”、“外挂”等非法互联网出版活动；
                      </p>
                      <p>e) 违反国家民族和宗教政策的信息；</p>
                      <p>f) 妨碍互联网运行安全的信息；</p>
                      <p>
                        g)
                        侵害他人合法权益的信息和/或有损于社会秩序、社会治安、公共道德的信息或内容；
                      </p>
                      <p>h) 其他违反法律法规、部门规章或国家政策的内容。</p>
                    </li>
                    <li>
                      4.4.4
                      不进行任何破坏或试图破坏网络安全的行为（包括但不限于钓鱼，黑客，网络诈骗，网站或空间中含有或涉嫌散播：病毒、木马、恶意代码，及通过虚拟服务器对其他网站、服务器进行涉嫌攻击行为如扫描、嗅探、ARP欺骗、DOS等）；
                    </li>
                    <li>
                      4.4.5 不从事其他违法、违规或违反我方服务条款的行为。
                    </li>
                    <li>
                      4.4.6
                      如您违反上述条款的约定，我方有权根据情况采取相应的处理措施，包括但不限于立即终止服务、中止服务或删除相应信息等。如果第三方机构或个人对您提出质疑或投诉，我方公司将通知您，您有责任在规定时间内进行说明并出具证明材料，如您未能提供相反证据或您逾期未能反馈的，我方将采取包括但不限于立即终止服务、中止服务或删除相应信息等处理措施。因您未及时更新联系方式或联系方式不正确而致使未能联系到您的，亦视为您逾期未能反馈。
                    </li>
                  </ul>
                </li>
                <li>
                  4.5
                  您使用“携客云服务”进行商务活动所引起的一切法律纠纷均与我方无关。{' '}
                </li>
                <li>
                  4.6
                  您对自己使用服务过程产生的数据以及进入和管理服务上各类产品与服务的账号、密码的完整性和保密性负责。因您维护不当或保密不当致使上述数据、口令、密码等丢失或泄漏所引起的一切损失和后果均由您自行承担。{' '}
                </li>
                <li>
                  4.7
                  如您违反本合同规定的任何条款，我方有权拒绝向您提供服务，并终止本合同。您已支付的“服务费”不予退还，同时我方公司有进一步追究客户法律责任的权利。
                </li>
              </ul>

              <h3>5．我方的权利与义务</h3>
              <ul>
                <li>
                  5.1
                  我方应按照《服务购买订单》约定提供服务,保证服务可持续运行及数据安全。
                </li>
                <li>
                  5.2
                  我方已获得必要的许可和授权，有权按本合同约定为客户提供服务。
                </li>
                <li>
                  5.3
                  我方不向其他任何第三方保证和承诺客户提交的网页和信息符合注册标准，客户自行对其携客云服务提供的内容、产品、服务等承担全部责任。
                </li>
                <li>
                  5.4
                  我方有权随时删除含有任何危害国家安全、淫秽色情、虚假、侮辱、诽谤、恐吓或骚扰、侵犯他人版权或人身权或其他合法权益等违法或有违社会公序良俗的内容。
                </li>
                <li>
                  5.5
                  我方保留为维护系统升级而短暂停止服务的权利，在暂停服务之前，将通过网站予以公告。
                </li>
                <li>
                  5.6
                  如果合同被终止（除由于违反合同协议致使合同终止之外），并我方可应您的要求在协议终止后的30日之内，向您提供一个关于数据信息的文件或获取文件的方法。
                </li>
                <li>
                  5.7
                  我方可以根据中国法律法规的调整、行政执法机关的命令和社会伦理道德的变化相应调整服务的审核标准。
                </li>
                <li>
                  5.8 在服务期限内，我方将按订单为您提供如下客户服务：
                  <ul>
                    <li>
                      5.8.1
                      为付费用户提供售后故障服务，并为付费用户提供有效的联系方式并保证付费用户能够联系到故障联系人。故障联系人在明确故障后及时进行反馈；
                    </li>
                    <li>
                      5.8.2
                      除正常工作时间外，提供7*24小时的紧急联系方式，解答客户在使用中的问题。
                    </li>
                  </ul>
                </li>
                <li>
                  5.9
                  我方承诺应严格遵守客户的数据保密义务。明确客户数据的所有权属于客户本身。
                </li>
              </ul>

              <h3>6. 数据隐私保护与保密责任</h3>
              <ul>
                <li>
                  6.1
                  除本协议另有约定外，本平台保证不对外公开或向第三方提供用户的注册资料及用户在使用本平台服务时存储在本平台上合法、非公开内容，但下列情况除外：
                  <ul>
                    <li>
                      <p>a) 事先获得用户的明确授权的。</p>
                      <p>b) 根据有关的法律法规要求，本平台必须提供的。</p>
                      <p>
                        c)
                        按照相关政府主管部门或司法部门的要求，本平台必须提供的。
                      </p>
                      <p>
                        d)
                        用户先行违反本协议内容造成本平台、他人或社会公共利益可能遭受损害的我方有权向相关当事人提供用户的相关信息。
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  6.2
                  在经您确认并同意：为了给您提供更好的体验，本平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本网站同等的保护用户隐私的责任，则本平台有权将用户的注册资料、个人发布信息等提供给该第三方。
                </li>
                <li>
                  6.3
                  双方将遵守保密资料的保密责任，保密资料指由一方向另一方披露的所有技术及非技术信息(包括但不限于产品资料，产品计划，价格，财务及营销规划，业务战略，客户信息，客户数据，研发，软件硬件，API应用数据接口，技术说明，设计，特殊公式，特殊算法等)。
                </li>
                <li>
                  6.4
                  本服务条款任何一方同意对获悉的对方之上述保密资料予以保密，并严格限制接触上述保密信息的员工遵守本条之保密义务。除非国家机关依法强制要求或上述保密资料已经进入公有领域外，接受保密资料的一方不得对外披露。
                </li>
                <li>
                  6.5
                  本服务条款双方明确认可各自用户信息和业务数据等是各自的重要资产及重点保密信息。本服务条款双方同意尽最大的努力保护上述保密信息等不被披露。一旦发现有上述保密信息泄露事件，双方应合作采取一切合理措施避免或者减轻损害后果的产生。
                </li>
                <li>6.6 本条款不因本服务条款的终止而失效。</li>
              </ul>

              <h3>7.协议终止</h3>
              <ul>
                <li>
                  7.1
                  为经营的需要，在任何时间，本平台都可以在以合理的方式通知用户，暂停或终止向用户提供全部或部分服务。对此，用户确认并予以理解，并承诺不因此追究本平台的任何责任。
                </li>
                <li>
                  7.2 出现下列情况时，本平台有权决定终止提供服务，并终止本协议：
                  <ul>
                    <li>
                      <p>a) 用户提供的信息不真实、不合法或不及时更新。</p>
                      <p>b) 利用本平台从事违法、犯罪活动的。</p>
                      <p>c) 被本平台注销用户、终止服务的。</p>
                      <p>d) 本平台修改或更新用户协议，用户不同意或不接受的。</p>
                      <p>e) 本协议另有规定或本平台认为需要终止的其他情形。</p>
                    </li>
                  </ul>
                </li>
                <li>
                  7.3 本协议终止后，用户同意本平台继续享有下述权利：
                  <ul>
                    <li>
                      <p>
                        a)
                        继续在本平台上保留用户信息及服务期间的使用情况或使用信息。
                      </p>
                      <p>
                        b)
                        在服务期间存在违法或违反本协议的行为，本平台可依据本协议主张权利。
                      </p>
                      <p>c) 法律、行政法规规定的及合同约定的其他情况。</p>
                    </li>
                  </ul>
                </li>
              </ul>

              <h3>8.通知与维权</h3>
              <ul>
                <li>
                  8.1
                  用户在使用本平台服务时，若发现本平台内容有违反法律、法规的规定或侵犯他人合法权益（包括但不限于肖像权、姓名权、名誉权、知识产权等），或用户认为相关信息侵犯了自身的合法权益，用户应当如实向本平台告知并提交下列材料：
                  <ul>
                    <li>
                      <p>a) 涉嫌侵权信息的具体内容及位置、链接等。</p>
                      <p>b) 自身享有合法权益的证明。</p>
                      <p>c) 自身联系人姓名、地址、电话号码或电子邮件。</p>
                      <p>d) 身份证复印件或营业执照复印件。</p>
                    </li>
                  </ul>
                </li>
                <li>
                  8.2请按上述要求通过电子邮件的方式发送给本平台邮箱（service@xiekeyun.com。）本平台将在在收到该材料后，经审查属实的，本平台将尽快删除相关信息，本平台仅接受电子邮件方式的侵权通知。
                </li>
              </ul>

              <h3>9. 违约责任</h3>
              <ul>
                <li>9.1 本服务条款任何一方违约均须依法承担违约责任。</li>
                <li>
                  9.2
                  您理解，鉴于计算机、互联网的特殊性，下述情况不属于我方违约：
                  <ul>
                    <li>
                      <p>
                        a)
                        我方在进行携客云服务配置、维护、升级时，需要短时间中断服务。
                      </p>
                      <p>
                        b)
                        我方提供的服务涉及到互联网及相关信息等服务，可能会受到Internet不稳定因素的影响。因此服务存在因上述不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机、通信网络、Internet等原因等造成您访问携客云速度下降或无法使用。
                      </p>
                      <p>
                        c)
                        由于您的故意或过失导致遭受损失的，我方不承担任何责任。
                      </p>
                      <p>
                        d)
                        如因我方原因，造成您连续72小时不能正常使用服务的，您可以终止服务，但非我方可控制之内的原因引起的除外。
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                  9.3
                  在任何情况下，我方对本服务条款所承担的违约赔偿责任总额不超过违约服务对应之服务费总额。
                </li>
              </ul>

              <h3>10. 法律适用与管辖</h3>
              <ul>
                <li>
                  本协议之效力、解释、执行与争议解决均适用中华人民共和国大陆地区法律，如无相关法律规定的，则应参照通用国际商业惯例和（或）行业惯例。用户与本平台一致同意，若因履行本协议而产生的争议，双方本着友好协商解决，协商不成的，双方同意提交我方运营公司注册地有管辖权的人民法院诉讼解决。
                </li>
                <li>
                  我方再次重申，在注册成为携客云用户之前，请仔细、详尽的阅读本协议，一经注册，用户应严格遵守该协议的所有条款，本平台有权根据经营的需要随时修改本协议，对于修改后的协议，用户可随时查阅。若用户对修订后的协议有异议，请及时联系本平台或停止使用本平台服务。
                </li>
              </ul>
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={this.affClick}
              className={classes.affBt}
              size="large"
              variant="contained"
              color="primary"
            >
              同意
            </Button>
          </DialogActions>
        </Dialog>
        <Toast icon="success-no-circle" show={this.state.showToast}>
          完成
        </Toast>
        <Toast icon="warn" show={this.state.showError}>
          {this.errorMsg}
        </Toast>
        <Toast icon="loading" show={this.state.showLoading}>
          Loading...
        </Toast>
      </div>
    );
  }
}

CreateCompany.propTypes = {
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    data: state.login,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CreateCompany));
